import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IGenderType } from "./routeType";

const { key, getPath } = getApi("types.gender.getAll");

type IExtractedRouteType = IGenderType["GenderTypeCollectionRetrieve"];

export type IGetGenderType = IPickCollectionQuery<IExtractedRouteType>;

const getGenderType: Fetcher<
  IGetGenderType["response"],
  IGetGenderType["variables"]
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetGenderType = createQuery({
  queryKey: [key],
  fetcher: getGenderType,
});
